import { useEffect, useRef } from 'react';

/**
 * setInterval that pauses while the browser tab is hidden.
 *
 * When the tab becomes visible again the callback runs once straight away and
 * the interval restarts. Pass enabled=false to stop polling. The first load is
 * left to the caller (this only handles the repeats).
 */
export default function useVisibleInterval(callback, delayMs, enabled = true) {
  const saved = useRef(callback);

  useEffect(() => {
    saved.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled || !delayMs) return undefined;
    let timer = null;
    const start = () => {
      clearInterval(timer);
      timer = setInterval(() => {
        if (!document.hidden) saved.current();
      }, delayMs);
    };
    const onVisibility = () => {
      if (document.hidden) {
        clearInterval(timer);
        timer = null;
      } else {
        saved.current();
        start();
      }
    };
    if (!document.hidden) start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [delayMs, enabled]);
}
